import React, { useContext } from 'react'
import { IntegrationsCol } from './integrations-col'
import { DomainIntegrationsManagerContext } from '../context'
import { BlueConicIntegrationsManager } from '../providers/blueconic/blueconic-integrations-manager'

const BLUECONIC_REC_FEAT_FLAG = 'FEAT_INTEGRATIONS_BLUECONIC_REC'

export const DataPlatformIntegrations: React.FC = () => {
    const { loading, domain } = useContext(DomainIntegrationsManagerContext)

    const isBlueConicFeatEnabled = domain?.flags?.includes(BLUECONIC_REC_FEAT_FLAG) ?? false

    return !isBlueConicFeatEnabled ? null : (
        <IntegrationsCol className="data-platform-integrations" label="Data Platforms" loading={loading}>
            <BlueConicIntegrationsManager />
        </IntegrationsCol>
    )
}
